module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Share permalink":"Link zur Kartenansicht teilen","Copy Hyperlink":"Link zur Kartenansicht kopieren","Copy HTML Embed Code":"HTML-Einbettungscode kopieren","Email Hyperlink":"Link zur Kartenansicht per Email versenden","An error occurred":"Ein Fehler ist aufgetreten","Copied":"Kopiert"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/sharebutton/ShareButton.vue
// module id = T1eq
// module chunks = 1